export default __webpack_public_path__ + "static/media/loaderIcon.c3e2c883.svg";